import { FlyerDataFormatOption } from "./flyer-detail-data.interface";

export const flyerDataFormats: FlyerDataFormatOption[] = [
  { label: "Print", value: "Print" },
  { label: "Digital", value: "Digital" },
  { label: "Both", value: "Both" },
];
